module.exports = __webpack_public_path__ + "img/DaltonJohn.4fcb7084.jpg";